// extracted by mini-css-extract-plugin
export default {"partner-page-toolbar":"PartnerPageToolbar_partner-page-toolbar__mDzSM"};